document.addEventListener('DOMContentLoaded', function () {
    function marginwellCustomJS() {
        // Hide instance of country dropdown 
        const countryDropdowns = document.querySelectorAll('[is="shipping-calculator--marginwell"] country-province [name="address[country]"], .accordion-details__content  country-province [name="address[country]"]');
        
        countryDropdowns.forEach(countryDropdown => {
            if (countryDropdown) {
                const newZealandOption = Array.from(countryDropdown.options).find(option => option.value === "New Zealand");

                if (newZealandOption) {
                    const onChangeHandler = () => {
                        const countryProvinceElement = document.querySelector("country-province");
                        if (countryProvinceElement && countryProvinceElement.firstElementChild) {
                            countryProvinceElement.firstElementChild.style.display = "none";
                        }
                        countryDropdown.removeEventListener("change", onChangeHandler);
                    };

                    countryDropdown.addEventListener("change", onChangeHandler);

                    countryDropdown.value = newZealandOption.value;
                    countryDropdown.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                }
            }
        });

        // Trigger marginwell submit on quantity change
        const quantityInput = document.querySelector('.quantity__input[name=quantity]');
        if (quantityInput) {
            const debouncedSubmit = FoxTheme.utils.debounce(() => {
                const zipInput = document.querySelector('[name="address[zip]"]');
                const form = document.querySelector('[is="shipping-calculator--marginwell"]');
                
                // Only trigger submit if zip code has a value and form exists
                if (zipInput && zipInput.value.trim() && form) {
                    form.dispatchEvent(new Event('submit', { bubbles: true }));
                }

                if(document.querySelectorAll('[data-stock-quantity], [data-backorder-quantity]')) {
                    const stock_quantity = parseInt(document.querySelector('[data-stock-quantity]').getAttribute('data-stock-quantity'), 10)
                    const backorder_quantity = Math.abs(parseInt(document.querySelector('[data-backorder-quantity]').getAttribute('data-backorder-quantity'), 10))
                    const quantity = parseInt(quantityInput.value, 10)
                    console.log(quantity, stock_quantity)
                    if (quantity > stock_quantity && stock_quantity > 0) {
                        document.querySelector('.product__block .backorder-calculator').style.display = 'flex';
                        document.querySelector('[data-backorder-quantity]').textContent = quantity - backorder_quantity;
                    }
                }
            }, 300);

            quantityInput.addEventListener('change', debouncedSubmit);
        }

        // Fetch Shipping Rates
        const form = document.querySelector('[is="shipping-calculator--marginwell"]');
        if (form)
            form.addEventListener('submit', function (e) {
                e.preventDefault();

                // Prevent button spam by disabling submit button
                const submitButton = form.querySelector('button[type="submit"]');
                if (submitButton) {
                    submitButton.disabled = true;
                    submitButton.textContent = 'Calculating...';
                }

                const formData = new FormData(form);
                let itemsArray = [];
                let quantity = document.querySelector('.quantity__input[name=quantity]');

                try {
                    itemsArray = JSON.parse(formData.get('product-information').replace(/,\s*([\]}])/g, '$1'));
                    if (quantity) {
                        itemsArray[0]['quantity'] = parseInt(quantity.value, 10)
                    }
                } catch (err) {
                    console.error(err);
                }

                const data = {
                    rate: {
                        origin: {
                            country: "NZ",
                            company_name: "Urban Sales"
                        },
                        destination: {
                            country: formData.get('address[country]'),
                            province: null,
                            postal_code: formData.get('address[zip]'),
                            city: formData.get('address[city]'),
                            name: null,
                            address1: null
                        },
                        items: itemsArray,
                        currency: formData.get('currency'),
                        locale: formData.get('locale')
                    }
                };

                fetch('//shopify-shipping.marginwell.io/shipping_rates/fetch', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'secret-key': 'squqctFDbI755ln1NwUcqFfnNU7ql'
                        },
                        body: JSON.stringify(data)
                    })
                    .then(res => {
                        if (!res.ok) {
                            throw new Error(`HTTP error! status: ${res.status}`);
                        }
                        return res.json();
                    })
                    .then(result => {
                        const container = document.querySelector('.product__block--inner--calculate-cost--result');
                        if (!container) return;

                        const existing = container.querySelector('.shipping-result');
                        if (existing) existing.remove();

                        const wrapper = document.createElement('div');
                        wrapper.className = 'gap shipping-result';

                        if (result.errors && result.errors.length) {
                            wrapper.innerHTML = `
                            <div class="alert alert--error blocks-radius grid gap-2" style="border-radius: 2rem">
                                <p class="font-body-bolder m-0">One or more errors occurred while retrieving the shipping rates:</p>
                                <ul class="list-disc grid gap-1 text-sm" role="list">
                                    ${result.errors.map(e => `<li>${e}</li>`).join('')}
                                </ul>
                            </div>`;
                        } else if (result.rates && result.rates.length) {
                            // Filter out "Local Pickup (Auckland)" service
                            const filteredRates = result.rates.filter(rate => 
                                rate.service_name !== 'Local Pickup (Auckland)'
                            );
                            
                            if (filteredRates.length > 0) {
                                wrapper.innerHTML = `
                                <div class="product__block--inner__title gap">
                                    <h5>
                                        Delivery to <span class="provincial-postal--text">${formData.get('address[country]')}, ${formData.get('address[zip]')}</span>
                                        <a href="javascript:" class="edit-btn">Edit</a>
                                    </h5>
                                    <ul class="list-disc grid gap-1 text-sm" role="list">
                                        ${filteredRates.map((rate, index) => {
                                        const price = (parseInt(rate.total_price, 10) / 100).toFixed(2);
                                        const checkedAttr = index === 0 ? 'checked' : '';
                                        return `
                                            <li>
                                                <span class="shipping-rate">
                                                    <input name="shipping-rate" type="radio" ${checkedAttr} /> ${rate.service_name}
                                                </span>
                                                <price data-price="${price}">$${price}</price>
                                                <p>${rate.description}</p>
                                            </li>
                                        `;
                                        }).join('')}
                                    </ul>
                                </div>`
                            } else {
                                wrapper.innerHTML = `<div class="alert alert--error blocks-radius">We couldn't find shipping rates for this postcode. Please double-check the postcode and region.</div>`;
                            }

                            document.querySelectorAll('country-province').forEach(el => {
                                el.style.display = 'none';
                            });
                        } else {
                            wrapper.innerHTML = `<div class="alert alert--error blocks-radius">We couldn't find shipping rates for this postcode. Please double-check the postcode and region.</div>`;
                        }

                        container.appendChild(wrapper);
                        document.querySelectorAll('.product__block--inner__title h5 a').forEach(el => {
                            el.addEventListener('click', () => { 
                                document.querySelectorAll('country-province').forEach(el => {
                                    el.style.display = 'block'; 

                                    document.querySelectorAll('.product__block--inner--calculate-cost--result .shipping-result').forEach(el => {
                                        el.remove();
                                    });
                                    
                                });
                            });
                        });

                        if (document.querySelector('.list-disc li:has(input:checked) price')) {
                            const del_fee_footer_el = document.querySelector('.cart-subtotal.cart-item-price.shipping--price')
                            const selected_del_price = parseFloat(document.querySelector('.list-disc li:has(input:checked) price').dataset.price)
                            const curr_total_price = parseFloat(document.querySelector('[data-hulkapps-cart-total]').textContent.replaceAll('$', ''))

                            document.querySelectorAll('.cart-subtotal.cart-item-price').forEach((el) => {el.style.display = 'flex';});
                            
                            del_fee_footer_el.querySelector('.label .shipping-to').textContent = `${formData.get('address[country]')}, ${formData.get('address[zip]')}`
                            del_fee_footer_el.querySelector('.price').textContent = `$${selected_del_price.toFixed(2)}`

                            document.querySelector('[data-hulkapps-cart-total]').textContent = `$${parseFloat(selected_del_price + curr_total_price).toFixed(2)}`
                        }

                    })
                    .catch(error => {
                        console.log(error)
                        const container = document.querySelector('.product__block--inner--calculate-cost--result');
                        if (!container) return;

                        const existing = container.querySelector('.shipping-result');
                        if (existing) existing.remove();

                        const wrapper = document.createElement('div');
                        wrapper.className = 'gap shipping-result';
                        wrapper.innerHTML = `<div class="alert alert--error blocks-radius">We couldn't find shipping rates for this postcode. Please double-check the postcode and region.</div>`;
                        
                        container.appendChild(wrapper);
                    })
                    .finally(() => {
                        // Re-enable submit button after request completes (success or error)
                        if (submitButton) {
                            submitButton.disabled = false;
                            submitButton.textContent = 'Calculate';
                        }

                        document.querySelector('[name="address[zip]"]').value = formData.get('address[zip]');
                        document.querySelector('[name="address[country]"]').value = formData.get('address[country]');
                        document.querySelector('[name="address[province]"]').value = formData.get('address[province]');
                    });
            });
    }
    marginwellCustomJS();
    document.addEventListener('trigger-change-shipping', marginwellCustomJS);      
});